<template>
  <div class="footer">
    <!-- <el-row :gutter="20" align="middle">
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <div class="padding-p">
          <p class="main-font pdding-top-20">
            江苏精益智控科技有限公司
          </p>
          <span class="main-font">http://www.jingyict.com</span>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" align="center">
        <div class="padding-p text-left">
          <p class="font-20">
            <i class="fa fa-mobile-phone fa-lg" aria-hidden="true"></i> &nbsp;13665181678
          </p>
          <p class="font-20">
            <i class="el-icon-phone-outline"></i> &nbsp;0510-85108968
          </p>
          <p class="font-20">
            <i class="fa fa-envelope-open-o" aria-hidden="true"></i>
            &nbsp;jingyict@aliyun.com
          </p>
          <p class="font-20">
            <i class="fa fa-address-card-o" aria-hidden="true"></i>
            &nbsp;江苏省无锡市滨湖区绣溪路53号15幢5-6层
          </p>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" align="left">
        <el-image
          :src="require('../assets/images/myqrcode.jpg')"
          class="qrcodeimage"></el-image>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-divider></el-divider> 
        <p class="font-20">
          江苏精益智控科技有限公司 版权所有苏ICP备18036996号-1
        </p>
        <p></p>
      </el-col>
    </el-row> -->
    <el-row>
       <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
             <p class="font-16 mt30">COPYRIGHT ©2022 江苏精益智控科技有限公司 版权所有苏ICP备18036996号-1</p>
             <p class="font-16">技术支持 江苏精益智控科技有限公司</p>
             <p class="font-16">客服热线 0510-85108968</p>
       </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isPc: true, //用来区分是否为手机端
    };
  },
  created() {
   this.isPc = this.$util.isPc();
  },
  mounted() {
  }
};
</script>
<style scoped>
.footer {
  /* background-color:  #0086b3;  */
  background-color: #414667;  
  width: 100%;
  color: #fff;
  height:150px;
}
.qrcodeimage {
  height: 150px;
  width: 150px;
  padding: 30px;
}
.qrcodephoneimage {
  height: 120px;
  width: 120px;
  padding: 5px;
}

.padding-p {
  padding: 20px 0 0 30px;
}
.text-left {
  text-align: left;
}
</style>